import { useEffect, useState } from 'react';
import { subscribeTermsSettings } from '@/data/settingsRepo';
import { makeEmptyTermsSettings, type TermsSettingsType } from '@/types/types_settings';

/**
 * Subscribes to the partner agreement — the wording the onboarding step shows
 * and the Settings screen edits.
 *
 * Starts blank rather than null, so no caller has to treat "not loaded yet" as a
 * third state, and `loading` tells the two apart for the two that care: the step
 * waits rather than announcing there is no agreement, and the admin form waits
 * rather than initialising its fields from blanks it is about to replace.
 */
export function useTermsSettings() {
  const [settings, setSettings] = useState<TermsSettingsType>(makeEmptyTermsSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return subscribeTermsSettings(
      (next) => {
        setSettings(next);
        setLoading(false);
      },
      (e) => {
        // Not fatal to the page, but it does mean the step has nothing to show —
        // which it then says, rather than putting an empty box above an "I
        // agree" checkbox. The document is world-readable, so this is a network
        // failure rather than a permissions one.
        console.error('Terms settings subscription failed', e);
        setLoading(false);
      },
    );
  }, []);

  return { settings, loading };
}
